var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonEfficiency = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 49", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { clipPath: "url(#icon-efficiency_svg__clip0_403_3034)" },
            React.createElement("path", { d: "M14.812 14.008a1.613 1.613 0 11.046 3.225 1.613 1.613 0 01-.046-3.226zm0-1.972a3.585 3.585 0 10.045 7.168 3.585 3.585 0 00-.045-7.168zM14.812 39.307a1.614 1.614 0 11.045 3.227 1.614 1.614 0 01-.045-3.227zm0-1.972a3.586 3.586 0 10.046 7.172 3.586 3.586 0 00-.046-7.172z", fill: fills.dark }),
            React.createElement("path", { d: "M33.21 39.307a1.614 1.614 0 11-1.613 1.613 1.592 1.592 0 011.613-1.613zm0-1.972a3.585 3.585 0 100 7.17 3.585 3.585 0 000-7.17zM9.636 26.803a1.613 1.613 0 110 3.227 1.613 1.613 0 010-3.227zm0-1.972a3.585 3.585 0 100 7.17 3.585 3.585 0 000-7.17zM38.409 26.803a1.613 1.613 0 110 3.227 1.613 1.613 0 010-3.227zm0-1.972a3.586 3.586 0 100 7.171 3.586 3.586 0 000-7.17z", fill: fills.light }),
            React.createElement("path", { d: "M20.885 7.016l-6.7 2.532V4.506l6.7 2.51z", fill: fills.dark }),
            React.createElement("path", { d: "M15.417 5.649h-1.232v7.095h1.232V5.649zM23.372 24.786a1.188 1.188 0 01-1.187-1.188v-6.655a1.188 1.188 0 011.188-1.188h6.677a1.188 1.188 0 010 2.376h-5.49v5.468a1.188 1.188 0 01-1.188 1.187z", fill: fills.dark }),
            React.createElement("path", { d: "M24.515 39.33a1.187 1.187 0 01-.627-2.197 10.891 10.891 0 00-.896-19.07 1.187 1.187 0 011.053-2.128A13.288 13.288 0 0125.12 39.15c-.181.114-.39.175-.605.18z", fill: fills.dark })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "icon-efficiency_svg__clip0_403_3034" },
                React.createElement("path", { fill: "#fff", transform: "translate(6.028 4.506)", d: "M0 0h35.944v40H0z" })))));
}, {
    name: identiconComponentName,
})({});
